/* dionis-pwp-popup.js | v1.1.0 | production build, comments stripped */
(function () {
  'use strict';

  const EG_PWP = {
    VERSION: '1.1.0',
    DEBUG: false,

    SESSION_KEY: 'dionis_pwp_sess_v1',
    STORAGE_KEY: 'dionis_pwp_v1',
    DECLINE_DAYS: 1,

    AUTO_OPEN_DELAY: 450,
    EVAL_DEBOUNCE: 300,
    VERIFY_DELAY: 600,
    SUCCESS_CLOSE: 950,

    COPY: {
      eyebrow: '',
      title: 'Your Order Qualifies For a Special Offer',
      sub: 'Add this to your order at a reduced price',
      subMany: 'Choose one to add to your order at a reduced price',
      noThanks: 'No thanks',
      chipText: 'Your special offer',
      addLabel: 'Add for {price}',
      addPlain: 'Add to cart',
      adding: 'Adding\u2026',
      added: 'Added \u2713',
      success: 'Added to your cart.',
      fail: 'Sorry, we could not apply the offer price. Nothing was added.',
      soldOut: 'Sold out',
      disclaimer: 'Offer price shown in cart. Limit one per order, while supplies last. Cannot be combined with other offers, discounts, or promo codes.'
    },

    _dialog: null,
    _evalTimer: null,
    _busy: false,
    _autoOpenPending: false,
    _autoOpenTimer: null,

    log() { if (this.DEBUG) console.log.apply(console, ['\uD83D\uDED2 PWP:'].concat([].slice.call(arguments))); },
    err() { console.error.apply(console, ['\uD83D\uDED2 PWP ERROR:'].concat([].slice.call(arguments))); },

    _eg() { return window.EG_CART_DRAWER || null; },

    _looksCartValueTrigger(t) {
      if (!t) return false;
      if (t.type === 'cartValue') return true;
      if (t.condition === 'value' && t.conditionMin != null) return true;
      if (t.minCartValue != null) return true;
      return false;
    },

    pwpRule() {
      const eg = this._eg();
      if (eg && typeof eg.getPwpRule === 'function') {
        try {
          const fromEg = eg.getPwpRule();
          if (fromEg) return fromEg;
        } catch (e) {  }
      }

      const meta = document.querySelector('meta#easygift-rules');
      if (!meta) return null;
      try {
        const rules = JSON.parse(meta.getAttribute('content') || '[]');
        if (!Array.isArray(rules)) return null;
        const self = this;
        const matches = rules.filter(function (r) {
          if (!r || !r.action || r.action.type !== 'offerToCustomer') return false;
          if (!self._looksCartValueTrigger(r.trigger)) return false;
          return /pwp/i.test(String(r.name || r.title || ''));
        });
        if (matches.length === 1) return matches[0];
        return null;
      } catch (e) { return null; }
    },

    ruleName(rule) { return (rule && (rule.name || rule.title)) || null; },

    ruleProducts(rule) {
      const products = (rule && rule.action && rule.action.products) || [];
      return products.slice(0, 3);
    },

    thresholdCents(rule) {
      const t = (rule && rule.trigger) || null;
      if (!t) return Infinity;
      if (t.condition === 'value' && t.conditionMin) return Math.round(t.conditionMin * 100);
      if (t.minCartValue) return Math.round(t.minCartValue * 100);
      if (typeof t.value === 'number') return Math.round(t.value * 100);
      if (typeof t.conditionMin === 'number') return Math.round(t.conditionMin * 100);
      this.log('PWP threshold not found in rule.trigger; defaulting to $50. trigger keys:', Object.keys(t));
      return 5000;
    },

    ruleDiscount(rule) {
      const a = (rule && rule.action) || {};
      const candidates = [a.discount, a, rule];
      for (let i = 0; i < candidates.length; i++) {
        const c = candidates[i];
        if (!c || typeof c !== 'object') continue;
        const type = c.discountType || (c.discount && c.discount.type) || c.valueType || c.type;
        let value = c.discountValue;
        if (value == null) value = (c.discount && c.discount.value);
        if (value == null) value = c.percentage;
        if (value == null && String(type).toLowerCase().indexOf('percent') !== -1) value = c.value;
        if (value != null && Number(value) && String(type).toLowerCase().indexOf('percent') !== -1) {
          return { type: 'percentage', value: Number(value) };
        }
        if (c.percentage != null && Number(c.percentage)) {
          return { type: 'percentage', value: Number(c.percentage) };
        }
      }
      this.log('PWP discount percent not found in rule; showing regular price. rule.action keys:', Object.keys(a));
      return null;
    },

    loadSession() {
      try {
        const raw = sessionStorage.getItem(this.SESSION_KEY);
        if (!raw) return { autoShown: false };
        return { autoShown: !!JSON.parse(raw).autoShown };
      } catch (e) { return { autoShown: false }; }
    },

    saveSession(s) {
      try { sessionStorage.setItem(this.SESSION_KEY, JSON.stringify(s)); } catch (e) {  }
    },

    declinedUntil() {
      try {
        const raw = localStorage.getItem(this.STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw).declinedUntil || null;
      } catch (e) { return null; }
    },

    setDeclined() {
      try {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
          declinedUntil: Date.now() + this.DECLINE_DAYS * 24 * 3600 * 1000
        }));
      } catch (e) {  }
    },

    isDeclined() {
      const until = this.declinedUntil();
      return !!(until && Date.now() < until);
    },

    async why() {
      const rule = this.pwpRule();
      let cart = null;
      try { cart = await this.getCart(); } catch (e) {  }

      const giftedName = rule ? this.ruleName(rule) : null;
      const products = rule ? this.ruleProducts(rule) : [];
      const offeredVariantIds = products.map(function (p) {
        return p.variants && p.variants[0] && p.variants[0].id;
      }).filter(Boolean);
      const accepted = (cart && giftedName) ? this.acceptedInCart(cart, giftedName, offeredVariantIds) : false;
      const threshold = rule ? this.thresholdCents(rule) : null;
      const qualifyingTotal = cart ? ((cart.total_price != null ? cart.total_price : cart.items_subtotal_price) || 0) : null;
      const meetsThreshold = (qualifyingTotal != null && threshold != null) ? (qualifyingTotal >= threshold) : null;
      const eligible = (meetsThreshold != null) ? (meetsThreshold && !accepted) : null;
      const declined = this.isDeclined();
      const autoShown = this.loadSession().autoShown;
      const slotPresent = !!this.chipSlot();
      const dialogOpen = !!(this._dialog && this._dialog.open);
      const hasCartDiscount = cart ? this._hasCartLevelDiscount(cart) : null;

      const dollars = function (c) { return (c == null) ? null : '$' + (c / 100).toFixed(2); };
      const info = {
        version: this.VERSION,
        ruleResolved: !!rule,
        giftedName: giftedName,
        productCount: products.length,
        offeredVariantIds: offeredVariantIds.join(',') || '(none)',
        threshold: dollars(threshold),
        total_price: cart ? dollars(cart.total_price) : null,
        items_subtotal_price: cart ? dollars(cart.items_subtotal_price) : null,
        meetsThreshold: meetsThreshold,
        alreadyAcceptedInCart: accepted,
        eligible: eligible,
        cartLevelDiscount: hasCartDiscount,
        isDeclined: declined,
        declinedUntil: this.declinedUntil() ? new Date(this.declinedUntil()).toLocaleString() : null,
        autoShownThisSession: autoShown,
        chipSlotPresent: slotPresent,
        dialogOpen: dialogOpen
      };

      let verdict;
      if (!rule) {
        verdict = 'HIDDEN: no PWP rule resolved. Binding contract: exactly ONE active EasyGift popup rule with a cart-value trigger whose name contains "PWP". Zero matches, two-plus matches, a paused rule, or a missing EG meta all fail closed.';
      } else if (eligible === false && accepted) {
        verdict = 'HIDDEN (correct): an offered PWP line is already in the cart, so the offer is used for this order. Remove it to re-test.';
      } else if (eligible === false) {
        verdict = 'HIDDEN (correct): the qualifying total is below the threshold (a discount may be dragging total_price under it).';
      } else if (hasCartDiscount) {
        verdict = 'HIDDEN (correct): an order-level discount is on the cart (an employee or promo code), which the EG product discount cannot combine with, so the offer stands down. Remove the code to offer it.';
      } else if (declined) {
        verdict = 'HIDDEN (correct): a ' + this.DECLINE_DAYS + '-day decline is active. Run EG_PWP.reset() to clear it for testing.';
      } else if (autoShown && !slotPresent) {
        verdict = 'ELIGIBLE, chip-only this session, but the drawer slot is not in the DOM right now. Open the cart drawer (the slot lives in the shipping-bar block).';
      } else if (autoShown) {
        verdict = 'ELIGIBLE: the auto-open was already used this session, so the reminder chip should be showing in the drawer.';
      } else {
        verdict = 'ELIGIBLE: the popup should auto-open now, or on the next qualifying cart event. If it is not, check the console for errors.';
      }

      try { console.log('%c\uD83D\uDED2 PWP why()', 'font-weight:bold;'); console.table(info); } catch (e) { console.log(info); }
      console.log(verdict);
      return info;
    },

    reset() {
      try { localStorage.removeItem(this.STORAGE_KEY); } catch (e) {  }
      try { sessionStorage.removeItem(this.SESSION_KEY); } catch (e) {  }
      this.hideChip();
      console.log('\uD83D\uDED2 PWP reset: decline + session cleared. Update the cart or reopen the drawer to re-trigger.');
    },

    async getCart() {
      const res = await fetch('/cart.js', { credentials: 'include' });
      if (!res.ok) throw new Error('cart fetch ' + res.status);
      return res.json();
    },

    _lineIsDiscounted(line) {
      if (!line) return false;
      const disc = Number(line.line_level_total_discount || 0);
      const allocs = line.line_level_discount_allocations || [];
      const perUnit = Math.round(line.final_line_price / line.quantity);
      return allocs.length > 0 && disc > 0 && perUnit < line.price;
    },

    acceptedInCart(cart, giftedName, variantIds) {
      const items = (cart && cart.items) || [];
      const ids = variantIds || [];
      return items.some(function (i) {
        const tagged = String((i.properties || {})._Gifted || '') === giftedName;
        if (!tagged) return false;
        if (ids.length && !ids.some(function (v) { return Number(v) === Number(i.variant_id); })) return false;
        return true;
      });
    },

    _hasCartLevelDiscount(cart) {
      if (!cart) return false;
      const apps = cart.cart_level_discount_applications;
      if (Array.isArray(apps) && apps.length > 0) return true;
      const sub = Number(cart.items_subtotal_price);
      const tot = Number(cart.total_price);
      if (isFinite(sub) && isFinite(tot) && sub > tot) return true;
      return false;
    },

    evaluate() {
      clearTimeout(this._evalTimer);
      this._evalTimer = setTimeout(this._evaluateNow.bind(this), this.EVAL_DEBOUNCE);
    },

    _clearAutoOpenTimer() {
      if (this._autoOpenTimer) { clearTimeout(this._autoOpenTimer); this._autoOpenTimer = null; }
      this._autoOpenPending = false;
    },

    async _evaluateNow() {
      const rule = this.pwpRule();
      if (!rule) { this.hideChip(); return; }

      const giftedName = this.ruleName(rule);
      const products = this.ruleProducts(rule);
      if (!giftedName || products.length === 0) { this.hideChip(); return; }

      let cart;
      try { cart = await this.getCart(); } catch (e) { return; }
      if (!cart) return;

      const offeredVariantIds = products.map(function (p) {
        return p.variants && p.variants[0] && p.variants[0].id;
      }).filter(Boolean);
      const accepted = this.acceptedInCart(cart, giftedName, offeredVariantIds);
      const threshold = this.thresholdCents(rule);

      const qualifyingTotal = (cart.total_price != null ? cart.total_price : cart.items_subtotal_price) || 0;
      const eligible = qualifyingTotal >= threshold && !accepted;

      if (!eligible) {
        this._clearAutoOpenTimer();
        this.hideChip();
        if (this._dialog && this._dialog.open) this.closeDialog('ineligible');
        return;
      }

      if (this._hasCartLevelDiscount(cart)) {
        this._clearAutoOpenTimer();
        this.hideChip();
        if (this._dialog && this._dialog.open) this.closeDialog('ineligible');
        return;
      }
      if (this.isDeclined()) {
        this._clearAutoOpenTimer();
        this.hideChip();
        if (this._dialog && this._dialog.open) this.closeDialog('ineligible');
        return;
      }

      const sess = this.loadSession();
      if (!sess.autoShown) {
        if (!this._autoOpenPending && !(this._dialog && this._dialog.open)) {
          this.hideChip();
          await this.openDialog(rule, products, giftedName, { delay: this.AUTO_OPEN_DELAY, auto: true });
        }
      } else if (!this._autoOpenPending && !(this._dialog && this._dialog.open)) {
        this.showChip();
      }
    },

    ensureDialog() {
      if (this._dialog && document.body.contains(this._dialog)) return this._dialog;

      const dlg = document.createElement('dialog');
      dlg.className = 'pwp-popup';
      dlg.id = 'dionis-pwp-popup';
      dlg.setAttribute('aria-labelledby', 'pwp-popup-title');
      dlg.setAttribute('aria-describedby', 'pwp-popup-sub');
      dlg.innerHTML =
        '<div class="pwp-popup__panel">' +
          '<button class="pwp-popup__close" type="button" data-pwp-close aria-label="Close offer">' + this._xSvg() + '</button>' +
          '<header class="pwp-popup__head">' +
            '<p class="pwp-popup__eyebrow">' + this._esc(this.COPY.eyebrow) + '</p>' +
            '<h2 class="pwp-popup__title" id="pwp-popup-title">' + this._esc(this.COPY.title) + '</h2>' +
            '<p class="pwp-popup__sub" id="pwp-popup-sub">' + this._esc(this.COPY.sub) + '</p>' +
          '</header>' +
          '<div class="pwp-popup__products" data-pwp-products></div>' +
          '<p class="pwp-popup__status" role="status" aria-live="polite" data-pwp-status></p>' +
          '<footer class="pwp-popup__foot">' +
            '<button class="pwp-popup__dismiss" type="button" data-pwp-no-thanks>' + this._esc(this.COPY.noThanks) + '</button>' +
          '</footer>' +
          '<p class="pwp-popup__fineprint">' + this._esc(this.COPY.disclaimer) + '</p>' +
        '</div>';

      document.body.appendChild(dlg);

      const self = this;

      dlg.addEventListener('click', function (e) { if (e.target === dlg) self.closeDialog('dismiss'); });
      dlg.querySelector('[data-pwp-close]').addEventListener('click', function () { self.closeDialog('dismiss'); });
      dlg.querySelector('[data-pwp-no-thanks]').addEventListener('click', function () { self.closeDialog('no-thanks'); });

      dlg.addEventListener('cancel', function (e) { e.preventDefault(); self.closeDialog('dismiss'); });

      this._dialog = dlg;
      return dlg;
    },

    async openDialog(rule, products, giftedName, opts) {
      opts = opts || {};
      const dlg = this.ensureDialog();

      this.setStatus('');
      await this.buildProducts(rule, products, giftedName);

      const subEl = dlg.querySelector('#pwp-popup-sub');
      if (subEl) {
        subEl.textContent = (products && products.length > 1) ? this.COPY.subMany : this.COPY.sub;
      }

      const self = this;
      const show = function () {
        self._autoOpenPending = false;
        if (!dlg.open) {
          try {
            dlg.showModal();
            if (opts.auto) { self.saveSession({ autoShown: true }); }
          } catch (e) {  }
        }
      };
      if (opts.delay) {
        this._clearAutoOpenTimer();
        this._autoOpenPending = true;
        this._autoOpenTimer = setTimeout(function () {
          self._autoOpenTimer = null;
          show();
        }, opts.delay);
      } else {
        show();
      }
    },

    closeDialog(reason) {
      const dlg = this._dialog;
      this._clearAutoOpenTimer();
      if (dlg && dlg.open) { try { dlg.close(); } catch (e) {  } }

      if (reason === 'no-thanks' || reason === 'chip-dismiss') {
        this.setDeclined();
        this.hideChip();
      } else if (reason === 'dismiss') {
        this.showChip();
      }
    },

    async buildProducts(rule, products, giftedName) {
      const dlg = this.ensureDialog();
      const container = dlg.querySelector('[data-pwp-products]');
      if (!container) return;

      container.setAttribute('data-count', String(products.length));
      const discount = this.ruleDiscount(rule);
      const self = this;

      let cart = null;
      try { cart = await this.getCart(); } catch (e) {  }

      const cards = await Promise.all(products.map(async function (p, idx) {
        const handle = p.handle;
        const variantId = (p.variants && p.variants[0] && p.variants[0].id) || null;
        let data = null;
        try {
          const res = await fetch('/products/' + handle + '.js', { credentials: 'include' });
          if (res.ok) data = await res.json();
        } catch (e) {  }
        const already = self._variantAccepted(cart, giftedName, variantId);
        return self.renderCard(p, data, variantId, discount, idx, already);
      }));

      container.innerHTML = cards.join('');

      container.querySelectorAll('[data-pwp-add]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.onAdd(btn); });
      });

      this._renderBVRatings(container);
    },

    _variantAccepted(cart, giftedName, variantId) {
      if (!cart || !variantId) return false;
      return (cart.items || []).some(function (i) {
        return Number(i.variant_id) === Number(variantId) &&
               String((i.properties || {})._Gifted || '') === giftedName;
      });
    },

    _renderBVRatings(container) {
      const nodes = container.querySelectorAll('[data-pwp-rating] [data-bv-product-id]');
      if (!nodes.length) return;
      const ids = [];
      nodes.forEach(function (n) {
        const id = n.getAttribute('data-bv-product-id');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      if (!ids.length) return;

      let attempts = 0;
      const tryRender = function () {
        attempts++;
        if (window.$BV && typeof window.$BV.ui === 'function') {
          try { window.$BV.ui('rr', 'inline_ratings', { productIds: ids }); } catch (e) {}
          return;
        }
        if (attempts < 20) setTimeout(tryRender, 200);
      };
      tryRender();
    },

    renderCard(p, data, variantId, discount, idx, already) {
      const title = (data && data.title) || p.title || 'Product';
      const safeTitle = this._esc(title);
      const available = data ? (data.available !== false) : true;

      let unit = null, compareAt = null;
      if (data) {
        const v = (data.variants || []).find(function (x) { return Number(x.id) === Number(variantId); }) || (data.variants || [])[0];
        if (v) {
          unit = v.price;
          compareAt = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null;
        } else if (typeof data.price === 'number') {
          unit = data.price;
        }
      }

      let sale = null, savedPct = null;
      if (unit != null && discount && discount.type === 'percentage' && discount.value) {
        sale = Math.round(unit * (1 - discount.value / 100));
        savedPct = Math.round(discount.value);
      }

      const priceShown = (sale != null) ? sale : unit;
      const struck = (sale != null && unit != null && sale < unit) ? unit : (compareAt || null);
      const expectedCents = (sale != null) ? sale : '';
      const titleId = 'pwp-card-title-' + idx;

      const img = (data && data.featured_image) ? this._img(data.featured_image, 320) : null;
      const mediaInner = img
        ? '<img class="pwp-card__img" src="' + img.s1 + '" srcset="' + img.s1 + ' 1x, ' + img.s2 + ' 2x" alt="' + safeTitle + '" loading="lazy" width="160" height="160">'
        : '<span class="pwp-card__img pwp-card__img--ph" aria-hidden="true"></span>';

      let priceAria = '';
      if (struck != null && priceShown != null) {
        priceAria = ' aria-label="Offer price ' + this._stripTags(this.money(priceShown)) + ', regular ' + this._stripTags(this.money(struck)) + '"';
      }

      const priceHtml =
        '<div class="pwp-card__price"' + priceAria + '>' +
          '<span class="pwp-card__price-now">' + this.money(priceShown != null ? priceShown : 0) + '</span>' +
          (struck != null ? '<s class="pwp-card__price-was" aria-hidden="true">' + this.money(struck) + '</s>' : '') +
          (savedPct ? '<span class="pwp-card__badge">Save ' + savedPct + '%</span>' : '') +
        '</div>';

      const actionHtml = !available
        ? '<span class="pwp-card__soldout">' + this._esc(this.COPY.soldOut) + '</span>'
        : already
          ? '<button class="pwp-card__add pwp-card__add--added" type="button" disabled>' + this._esc(this.COPY.added) + '</button>'
          : '<button class="pwp-card__add" type="button" data-pwp-add data-variant-id="' + variantId + '" data-unit-cents="' + expectedCents + '">' +
              this._esc(priceShown != null ? this._fmt(this.COPY.addLabel, { price: this._stripTags(this.money(priceShown)) }) : this.COPY.addPlain) +
            '</button>';

      const bvProductId = (data && data.id != null) ? String(data.id) : '';
      const bvUrl = (data && data.url) ? data.url : ('/products/' + (p.handle || ''));
      const ratingHtml = bvProductId
        ? '<div class="pwp-card__rating" data-pwp-rating>' +
            '<div data-bv-show="inline_rating" data-bv-product-id="' + bvProductId + '" data-bv-redirect-url="' + this._esc(bvUrl) + '" data-bv-seo="false"></div>' +
          '</div>'
        : '';

      return '' +
        '<article class="pwp-card' + (available ? '' : ' pwp-card--soldout') + '" aria-labelledby="' + titleId + '">' +
          '<div class="pwp-card__media">' + mediaInner + '</div>' +
          '<h3 class="pwp-card__title" id="' + titleId + '">' + safeTitle + '</h3>' +
          ratingHtml +
          priceHtml +
          actionHtml +
        '</article>';
    },

    async onAdd(button) {
      if (this._busy) return;
      const variantId = button.getAttribute('data-variant-id');
      const expectedCents = parseInt(button.getAttribute('data-unit-cents') || '0', 10) || 0;
      const rule = this.pwpRule();
      const giftedName = this.ruleName(rule);

      if (!variantId || variantId === 'null' || !giftedName) {
        this.setStatus(this.COPY.fail);
        return;
      }

      const preProducts = this.ruleProducts(rule);
      const preVariantIds = preProducts.map(function (p) {
        return p.variants && p.variants[0] && p.variants[0].id;
      }).filter(Boolean);
      let preCart;
      try { preCart = await this.getCart(); } catch (e) { this.setStatus(this.COPY.fail); return; }
      const preThreshold = this.thresholdCents(rule);
      const preTotal = (preCart.total_price != null ? preCart.total_price : preCart.items_subtotal_price) || 0;
      if (preTotal < preThreshold ||
          this.isDeclined() ||
          this._hasCartLevelDiscount(preCart) ||
          this.acceptedInCart(preCart, giftedName, preVariantIds)) {
        this.hideChip();
        this.closeDialog('accepted');
        return;
      }

      this._busy = true;
      this._setBusy(button, true);
      this.setStatus('');

      try {
        const added = await this.replayAdd(variantId, giftedName);
        if (!added) { this._failAdd(button); return; }

        await this._wait(this.VERIFY_DELAY);
        const v = await this.verifyLine(variantId, giftedName, expectedCents);

        if (!v.ok) {
          this.err('verify failed, rolling back', v);
          if (v.line && v.line.key) await this.rollback(v.line.key);
          this._failAdd(button);
          return;
        }

        this._markAdded(button);
        this.setStatus(this.COPY.success);

        const eg = this._eg();
        if (eg && typeof eg.refreshCart === 'function') {
          if (typeof eg.invalidateCartCache === 'function') eg.invalidateCartCache();
          eg.refreshCart();
        } else {
          window.dispatchEvent(new CustomEvent('theme:cart:updated'));
        }

        const self = this;
        const onCartPage = /\/cart\/?$/.test(window.location.pathname);
        setTimeout(function () {
          self.closeDialog('accepted');
          if (onCartPage) { try { window.location.reload(); } catch (e) {  } }
        }, this.SUCCESS_CLOSE);
      } catch (e) {
        this.err('add error', e);
        this._failAdd(button);
      } finally {
        this._busy = false;
      }
    },

    replayAdd(variantId, giftedName) {
      const fd = new FormData();
      fd.append('items[0][id]', String(variantId));
      fd.append('items[0][quantity]', '1');
      fd.append('items[0][properties][_Gifted]', giftedName);

      return fetch('/cart/add.js?_easygift_internal=true', {
        method: 'POST',
        credentials: 'include',
        body: fd
      }).then(function (res) { return res.ok; }).catch(function () { return false; });
    },

    async verifyLine(variantId, giftedName, expectedCents) {
      let cart;
      try { cart = await this.getCart(); } catch (e) { return { ok: false, line: null, reason: 'cart-fetch' }; }

      const self = this;
      const matches = (cart.items || []).filter(function (i) {
        return Number(i.variant_id) === Number(variantId) &&
               String((i.properties || {})._Gifted || '') === giftedName;
      });
      if (!matches.length) return { ok: false, line: null, reason: 'line-missing' };

      const good = matches.find(function (l) { return self._lineIsDiscounted(l); });
      const line = good || matches[matches.length - 1];

      const perUnit = Math.round(line.final_line_price / line.quantity);
      const disc = line.line_level_total_discount || 0;
      const ok = this._lineIsDiscounted(line);

      if (ok && expectedCents && perUnit !== expectedCents) {
        this.log('verify ok, but per-unit ' + perUnit + ' != expected ' + expectedCents + ' (cosmetic only)');
      }
      return { ok: ok, line: line, perUnit: perUnit, disc: disc };
    },

    rollback(lineKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).catch(function () {  });
    },

    chipSlot() { return document.querySelector('#dionis-pwp-slot, [data-pwp-slot]'); },

    showChip() {
      const slot = this.chipSlot();
      if (!slot) return;
      if (slot.querySelector('.pwp-chip')) return;
      slot.innerHTML = this.renderChip();

      const self = this;
      const open = slot.querySelector('[data-pwp-chip-open]');
      const dismiss = slot.querySelector('[data-pwp-chip-dismiss]');
      if (open) open.addEventListener('click', function () { self.openDialogFromChip(); });
      if (dismiss) dismiss.addEventListener('click', function () { self.closeDialog('chip-dismiss'); });
    },

    hideChip() {
      const slot = this.chipSlot();
      if (slot && slot.innerHTML !== '') slot.innerHTML = '';
    },

    renderChip() {
      return '' +
        '<div class="pwp-chip" role="group" aria-label="Special offer">' +
          '<button class="pwp-chip__open" type="button" data-pwp-chip-open aria-haspopup="dialog">' +
            '<span class="pwp-chip__icon" aria-hidden="true">' + this._tagSvg() + '</span>' +
            '<span class="pwp-chip__text">' + this._esc(this.COPY.chipText) + '</span>' +
            '<span class="pwp-chip__cta" aria-hidden="true">View</span>' +
          '</button>' +
          '<button class="pwp-chip__dismiss" type="button" data-pwp-chip-dismiss aria-label="Dismiss this offer">' + this._xSvg() + '</button>' +
        '</div>';
    },

    async openDialogFromChip() {
      const rule = this.pwpRule();
      if (!rule) return;

      const giftedName = this.ruleName(rule);
      const products = this.ruleProducts(rule);
      if (!giftedName || products.length === 0) { this.hideChip(); return; }

      let cart;
      try { cart = await this.getCart(); } catch (e) { return; }

      const offeredVariantIds = products.map(function (p) {
        return p.variants && p.variants[0] && p.variants[0].id;
      }).filter(Boolean);
      const threshold = this.thresholdCents(rule);
      const qualifyingTotal = (cart.total_price != null ? cart.total_price : cart.items_subtotal_price) || 0;

      if (qualifyingTotal < threshold ||
          this.isDeclined() ||
          this._hasCartLevelDiscount(cart) ||
          this.acceptedInCart(cart, giftedName, offeredVariantIds)) {
        this.hideChip();
        return;
      }

      this.openDialog(rule, products, giftedName, { delay: 0 });
    },

    setStatus(msg) {
      const dlg = this._dialog;
      if (!dlg) return;
      const el = dlg.querySelector('[data-pwp-status]');
      if (el) el.textContent = msg || '';
    },

    _setBusy(button, busy) {
      if (!button) return;
      if (busy) {
        button.dataset.label = button.textContent;
        button.textContent = this.COPY.adding;
        button.disabled = true;
      } else {
        if (button.dataset.label) button.textContent = button.dataset.label;
        button.disabled = false;
      }
    },

    _markAdded(button) {
      if (!button) return;
      button.textContent = this.COPY.added;
      button.classList.add('pwp-card__add--added');
      button.disabled = true;
    },

    _failAdd(button) {
      this.setStatus(this.COPY.fail);
      this._setBusy(button, false);
    },

    _wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); },

    money(cents) {
      cents = Math.round(Number(cents) || 0);
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
        try { return Shopify.formatMoney(cents, Shopify.money_format); } catch (e) {  }
      }
      return '$' + (cents / 100).toFixed(2);
    },

    _img(url, size) {
      const base = String(url).split('?')[0];
      const eg = this._eg();
      const webp = (eg && typeof eg.supportsWebP === 'function' && eg.supportsWebP()) ? '&format=webp' : '';
      return {
        s1: base + '?width=' + size + webp,
        s2: base + '?width=' + (size * 2) + webp
      };
    },

    _esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },

    _stripTags(s) { return String(s == null ? '' : s).replace(/<[^>]*>/g, ''); },

    _fmt(tpl, vars) {
      return String(tpl).replace(/\{(\w+)\}/g, function (m, k) { return (vars[k] != null) ? vars[k] : m; });
    },

    _xSvg() {
      return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    },

    _tagSvg() {
      return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.2" fill="currentColor" stroke="none"/></svg>';
    },

    // ----------------------------------------------------------------------
    // INIT
    // ----------------------------------------------------------------------

    init() {
      const self = this;

      window.addEventListener('theme:cart:updated', function () { self.evaluate(); });
      window.addEventListener('theme:cart:add', function () { self.evaluate(); });

      // Drawer-open proxy: re-check when the cart drawer is opened (cart may
      // already be >= threshold with no recent change).
      document.addEventListener('click', function (e) {
        const t = e.target;
        if (t && t.closest && t.closest('[data-drawer-open="right"], .header--cart, [data-drawer-open]')) {
          setTimeout(function () { self.evaluate(); }, 350);
        }
      }, true);

      // Initial check (cart already eligible on load / drawer already open).
      setTimeout(function () { self.evaluate(); }, 800);

      this.log('ready', this.VERSION);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { EG_PWP.init(); });
  } else {
    EG_PWP.init();
  }

  window.EG_PWP = EG_PWP;
})();